import css from 'styled-jsx/css';

const styles = css.global`.info {
  margin-top: 40px;
  box-sizing: border-box;
}

.info.hidden {
  display: none !important;
}

.info .info-title {
  font-family: 'SantanderHeadline';
  font-weight: 400;
  font-size: 32px;
  line-height: 42px;
  letter-spacing: 0%;
  color: #222;
  max-width: 288px;
}

.info .info-subtitle {
  font-family: 'SantanderMicroText';
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  color: #222222;
  margin-top: 32px;
}

.info .button-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 40px;
  margin: 40px 0;
}

.info .text-rooftype {
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin-bottom: 16px;
  color: #222222;
}

.info .form-render {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  gap: 32px;
  max-width: 520px;
}

.info .button-row-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  padding-top: 24px;
  padding-bottom: 24px;
  margin: 88px 0 0;
  border-top: 1px solid #cccccc;
}

.info .field-wrapper {
  position: relative;
}

.info #cta-nao-sei-cep {
  font-family: 'SantanderText';
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: right;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;

  color: #cc0000;

  cursor: pointer;
  text-align: right;
  margin-left: auto;
  display: block;
  box-sizing: border-box;
  width: fit-content;
}

.info .form-render .postal-code .text-field__helper.error {
  position: absolute;
  margin: 0;
  bottom: -6px;
  left: 14px;
  transform: translateY(100%);
}

#chk-sem-numero {
  margin-top: 26px;
}

.info .simulation-type-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
}

.info .simulation-type-wrapper .checkbox-component.radio .chk-container .label {
  text-wrap: nowrap;
  letter-spacing: 0%;
}

.info .text-informative {
  color: #222222;
  font-family: SantanderText;
  font-weight: bold;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  margin-top: 40px;
}

.info .form-render.has-selected {
  margin-top: 40px;
}

.info .form-render .text-extra-label {
  font-family: SantanderMicroText;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  margin: 0 0 30px;
  color: #222222;
}

.info .form-render .text-extra-label small {
  font-size: 14px;
  line-height: 22px;
}

.info .field-searchStore.has-value .text-field__end-adornment {
  pointer-events: all !important;
  z-index: 3;
  cursor: pointer;
}

.info .store-results-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;

  width: 100%;
  max-width: 242px;

  gap: 24px;
  margin: 0 auto 0;
}

.info .loading-stores .field-searchStore .text-field__helper {
  display: none !important;
}

.info.has-store-results .button-row-form {
  position: sticky;
  bottom: 0;
  background: #fff;
  z-index: 10;
}

@media (min-width: 768px) {
  .info .store-results-container {
    flex-direction: row;
    align-items: flex-start;
    max-width: unset;
    flex-wrap: wrap;
    margin: 8px 0 0;
  }

  .info .store-results-container .card-store {
    max-width: 242px;
  }
}

@media (min-width: 992px) {
  .info .info-title {
    font-size: 40px;
    line-height: 60px;
    max-width: unset;
  }

  .info .button-row-form {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 0;
  }

  .info .button-row-form button:nth-child(1) {
    max-width: 120px;
  }
  .info .button-row-form button:nth-child(2) {
    max-width: 228px;
  }

  .info .form-render {
    max-width: 100%;
  }

  .info .form-render .field-wrapper {
    max-width: 520px;
  }

  .info .form-render .field-wrapper.field-roofType {
    max-width: 100%;
  }

  .info .form-render .field-wrapper.field-roofType .select-field {
    max-width: 520px;
  }
}
`;

export default styles;